import { useEffect, useState } from "react";
import * as React from 'react';
import { useLocation } from "react-router-dom";
import { NavList } from './nav_list';
import { IUser } from '../../types/user';
import { INavItemTopLine } from '../../types/nav';
import { TDeviceType } from "@cian/ui-kit";
import { IMenuRubrics, IRubric } from '../../reducers/modules/rubrics_menu/rubrics_menu';
import { getMenuRubricsData, selectRubric, removeSlashes } from '../../../app/utils';

import s from './nav.css';

interface IProps {
  deviceType: TDeviceType;
  currentUser: IUser;
  activeItem?: string;
  toggleSearch(open: boolean): void;
  toggleRegions(open: boolean): void;
  regionName: string;
  refreshScroll(): void;
  navItems: IMenuRubrics[];
}

export const Nav: React.FC<IProps> = props => {
  const [showNav, setShowNav] = useState(false);
  const [navDown] = useState(false);
  const [navUp] = useState(false);
  const [stuck] = useState(false);
  const [navItemsTopLine, setNavItemsTopLine] = useState<INavItemTopLine[]>([]);

  useEffect( () => {
    setNavItemsTopLine([{
      id: 'home',
      name: 'Журнал',
      onSubmit: () => window.location.assign('/magazine/'),
      icon: 'home',
    }, {
      id: 'search',
      name: 'Поиск по журналу',
      onSubmit: () => { props.toggleSearch(true); },
      icon: 'search',
    }, {
      id: 'geolocation',
      name: decodeURIComponent(props.regionName),
      onSubmit: () => props.toggleRegions(true),
      icon: 'region',
    }]);
  }, [props]);

  const handleGeolocationButtonClick = () => {
    const geolocationButton = navItemsTopLine.find(({ id }: INavItemTopLine) => id === 'geolocation');

    onNavigationClick();
    if (geolocationButton) { geolocationButton.onSubmit(); }
  }

  const handleSearchButtonClick = () => {
    onNavigationClick();
    props.toggleSearch(true);
  }

  function activeNavItem() {
    if (props.activeItem) {
      return props.activeItem;
    }

    // делаем одномерный массив всех рубрик для вычисления активного итема
    const plainNavItems: IRubric[] = getMenuRubricsData(props.navItems)(selectRubric);

    const foundedItem = plainNavItems.map(findActiveItem).find((name: string) => Boolean(name));

    return foundedItem || '';
  }

  const findActiveItem = (item: IRubric): string => {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const { pathname } = location;
    const queryCategory = query.get('category');
    const categories = item.categories;

    // Если выбрана категория, то выделяем её
    if (queryCategory && categories && categories[queryCategory]) {
      return categories[queryCategory];
    }

    // Если путь из квери совпадает с path итема, то выделяем итем
    if (pathname.includes(removeSlashes(item.pathname))) {
      return item.name;
    }

    return '';
  }

  const toggleNav = () => {
    setShowNav(!showNav);
  }

  const onNavigationClick = () => {
    props.refreshScroll();
    setShowNav(false);
  }

  return (
    <div
      id={s['main-nav-container']}
      className={`cg-col-24 cg-col-xs-24 ${s['sidebar']} ${navDown ? s['nav-down'] : ''} ${navUp ? s['nav-up'] : ''}`}
    >
      <span className={s['float-placeholder']}>&nbsp;</span>
      <nav
        id="main-nav"
        className={`${stuck ? 'cg-col-4' : 'cg-col-24'} cg-col-xs-5 ${s['main-nav']} ${stuck ? s['stuck'] : ''}`}
      >
        <button className={s['nav__activeLink']}>
          <span onClick={toggleNav} className={s['nav__activeLink_text-wrap']}>
            <span className={s['nav__activeLink_text']}> Журнал </span>
            <span className={`${s['nav__activeLink_icon']} ${showNav ? s['nav__activeLink_icon-active'] : ''}`} />
          </span>
        </button>
        <div className={s['nav__top-line_actions-section']}>
          <button
            className={s['nav__top-line_link']}
            onClick={handleGeolocationButtonClick}
          >
            <span className={s['nav__top-line_geolocation-icon']} />
          </button>

          <button
            className={s['nav__top-line_link']}
            onClick={handleSearchButtonClick}
          >
            <span className={s['nav__top-line_search-icon']} />
          </button>
        </div>

        <NavList
          deviceType={props.deviceType}
          currentUser={props.currentUser}
          navItems={props.navItems}
          activeNavItem={activeNavItem()}
          showNav={showNav}
          onNavigationClick={onNavigationClick}
          navDown={navDown}
          navItemsTopLine={navItemsTopLine}
        />
      </nav>
    </div>
  );
}
